import { TEMPLATE_TYPES } from '@/consts/template';
import { DISTRIBUTION_CHANNEL } from '@/consts/survey';

export default {
  /**
   * Pass the template type and get key from distribution object
   * @param {number} templateType
   * @returns
   */
  getTemplateKeyByType: () => (templateType) => {
    if (templateType === TEMPLATE_TYPES.SURVEY_COMPLETED) {
      return 'template_survey_thanks_hash';
    }
    if (templateType === TEMPLATE_TYPES.SURVEY_EXPIRED) {
      return 'template_survey_expired_hash';
    }
    if (templateType === TEMPLATE_TYPES.SURVEY_INVITE) {
      return 'template_email_invite_hash';
    }
    if (templateType === TEMPLATE_TYPES.SURVEY_REMINDER) {
      return 'template_email_reminder_hash';
    }
    if (templateType === TEMPLATE_TYPES.SURVEY_INVITE_LINKSMS) {
      return 'template_smslink_invite_hash';
    }
    if (templateType === TEMPLATE_TYPES.SURVEY_REMINDER_LINKSMS) {
      return 'template_smslink_reminder_hash';
    }
  },
  isDistributed(state) {
    const { distribution } = state;
    return (
      distribution.distribution_channel !== DISTRIBUTION_CHANNEL.LINK
      && distribution.distribution_channel !== DISTRIBUTION_CHANNEL.QRCODE
      && distribution.distribution_channel !== DISTRIBUTION_CHANNEL.WIDGET
    );
  },
  enableNextTab(state) {
    const { distribution } = state;
    if (!distribution.distribution_channel) {
      return false;
    }
    if (
      distribution.distribution_channel !== DISTRIBUTION_CHANNEL.WHATSAPP
      || distribution.whatsapp_integration_uuid
    ) {
      return true;
    }
    return false;
  },
};
